import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export const Footer = () => {
  return (
    <footer className="bg-card border-t border-border/30">
      {/* Main Footer */}
      <div className="container-wide py-12 sm:py-16 md:py-24 lg:py-32">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-2">
            <Logo size="sm" className="mb-4 md:mb-6" />
            <p className="body-md max-w-md">
              A experiência de um family office, de forma acessível, independente e transparente.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h2 className="font-sans text-xs sm:text-sm font-semibold text-foreground mb-3 md:mb-4">
              Navegação
            </h2>
            <nav className="flex flex-col gap-2 sm:gap-3">
              <Link to="/" className="text-muted-foreground hover:text-foreground transition-colors text-xs sm:text-sm">
                Início
              </Link>
              <Link to="/#nossa-trajetoria" className="text-muted-foreground hover:text-foreground transition-colors text-xs sm:text-sm">
                Nossa Trajetória
              </Link>
              <Link to="/#o-que-oferecemos" className="text-muted-foreground hover:text-foreground transition-colors text-xs sm:text-sm">
                O que Oferecemos
              </Link>
              <Link to="/#como-funciona" className="text-muted-foreground hover:text-foreground transition-colors text-xs sm:text-sm">
                Como Funciona
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h2 className="font-sans text-xs sm:text-sm font-semibold text-foreground mb-3 md:mb-4">
              Contato
            </h2>
            <nav className="flex flex-col gap-2 sm:gap-3">
              <Link to="/#diferenciais" className="text-muted-foreground hover:text-foreground transition-colors text-xs sm:text-sm">
                Nossos Diferenciais
              </Link>
              <Link to="/contato" className="text-muted-foreground hover:text-foreground transition-colors text-xs sm:text-sm">
                Fale Conosco
              </Link>
            </nav>
          </div>
        </div>
      </div>

      {/* Compliance Footer */}
      <div className="border-t border-border/30">
        <div className="container-wide py-6 sm:py-8">
          <div className="flex flex-col gap-4 sm:gap-6 lg:flex-row lg:justify-between">
            <div className="text-xs sm:text-sm text-muted-foreground">
              <span>allu.capital</span>
            </div>
            <p className="text-xs sm:text-sm text-muted-foreground">
              © {new Date().getFullYear()} allu.capital. Todos os direitos reservados.
            </p>
          </div>

          <div className="mt-4 sm:mt-6 pt-4 sm:pt-6 border-t border-border/20">
            <p className="text-[10px] sm:text-xs text-muted-foreground leading-relaxed max-w-4xl">
              A allu.capital atua de forma consultiva. Não somos corretora de valores. 
              Não prometemos rentabilidade. Não realizamos divulgação pública de valores mobiliários. 
              As informações contidas neste site não constituem oferta de produtos ou serviços financeiros.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
